import { Layout, Card, Loading } from 'element-react';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useTranslation } from 'react-i18next';

import SupplierSwiperItem from './SupplierSwiperItem';

import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/scrollbar/scrollbar.scss';
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

export default function SuppliersSwiper({ slidesPerView, spaceBetween, suppliers, loading }) {
    const { t } = useTranslation();
    function renderSuppliers() {
        return suppliers && suppliers.map(supplier => {
            return(
                <SwiperSlide className="swiper-item" key={supplier.id}>
                    <SupplierSwiperItem supplier={supplier} />
                </SwiperSlide>
            )
        })
    }

    return (
        <Layout.Row >
            <Layout.Col span="24">
                <Card className="box-card">
                    <Layout.Row>
                        <Layout.Col span="24" >
                            { loading ? 
                                <Loading className="p-t-md p-b-xl" text={t('general.loading')} loading={true} fullscreen={false}/>
                                :
                                <Swiper navigation={true} modules={[Navigation]}
                                spaceBetween={spaceBetween} 
                                slidesPerView={slidesPerView} 
                                loop={true} 
                                slidesPerGroup={1}
                                breakpoints={{
                                    320: {
                                        slidesPerView: 1,
                                        spaceBetween: 15,
                                    },
                                    768: {
                                        slidesPerView: 2,
                                        spaceBetween: 15,
                                    },
                                    1024: {
                                        slidesPerView: 4,
                                        spaceBetween: 10,
                                    },
                                  }}
                                >
                                    {renderSuppliers()}
                                </Swiper>
                            }
                        </Layout.Col>
                    </Layout.Row>
                </Card>
            </Layout.Col>
        </Layout.Row>
    )
}
